function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8884 0.840187L19.2452 6.13002C19.7151 6.59401 19.7151 7.3463 19.2452 7.8103L13.8884 13.1001C13.4185 13.5641 12.6567 13.5641 12.1868 13.1001L11.2233 12.1487L14.5815 8.83253C15.2168 8.20517 15.5345 7.89148 15.6535 7.52977C15.7582 7.2116 15.7582 6.86886 15.6535 6.55068C15.5345 6.18897 15.2168 5.8753 14.5815 5.24793L14.5815 5.24792L11.1523 1.86168L12.1868 0.840187C12.6567 0.376188 13.4185 0.376188 13.8884 0.840187Z",
  fill: "#576575"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.83403 1.7113L7.95187 0.840187C7.48199 0.376188 6.72017 0.376188 6.25029 0.840187L0.893425 6.13001C0.423546 6.59401 0.423546 7.3463 0.893425 7.8103L6.25029 13.1001C6.72017 13.5641 7.48199 13.5641 7.95187 13.1001L8.76307 12.2991L5.25259 8.83253C4.61728 8.20517 4.29962 7.89148 4.1806 7.52977C4.0759 7.2116 4.0759 6.86886 4.1806 6.55068C4.2996 6.18901 4.6172 5.87538 5.25236 5.24815L5.25259 5.24792L8.83403 1.7113Z",
  fill: "#576575"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3428 6.47995L10.4134 3.5872C10.1001 3.27786 9.59225 3.27786 9.279 3.5872L6.34958 6.47995C6.03633 6.78928 6.03633 7.29081 6.34958 7.60014L9.279 10.4929C9.59225 10.8022 10.1001 10.8022 10.4134 10.4929L13.3428 7.60014C13.6561 7.29081 13.6561 6.78928 13.3428 6.47995Z",
  fill: "#576575"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.0424805,
  width: 20.0533,
  height: 14.0597,
  fill: "white"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.8815621f.svg";
export { ForwardRef as ReactComponent };